var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WmButton, WmDatepicker, WmOption, WmSelect, } from "@watermarkinsights/ripple-react";
import translate from "../../i18n/translate";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { focusActionMenuComponent, focusButtonComponent, isNullOrEmpty, navigateToElement, } from "../../static/js/commons.js";
import { applicationSelector, getAllApplicationComponents, getAllApplicationTemplates, getOrganizationAndChildOrganizations, placeComponentToNewPosition, removeComponent, resetApplicationTemplateComponentsList, saveTemplate, setApplicationTemplate, setIsEditComponentClicked, updateTemplate, setAriaMoveText, setBlockMovement, placeComponentToNewPositionKeyboard, setComponentsListData, setComponentDetails, } from "./ApplicationSlice";
import InsertComponent from "./InsertComponent";
import PreviewTemplate from "./PreviewTemplate";
import DiscardModal from "../../features/common/component/DiscardWmModal";
import Inputfield from "../common/component/InputField";
import DeleteModal from "../../features/common/component/DeleteWmModal";
import { useParams } from "react-router-dom";
import InformationModal from "../../features/common/component/InformationWmModal";
import { TemplateComponentList } from "./data/TemplateComponentList";
import { getIdByKey, getUploaderFiles, } from "../../features/common/commonActions";
import ResourceLink from "./template-components/ResourceLink";
import ResourceAttachment from "./template-components/ResourceAttachment";
import StudentInputLink from "./template-components/StudentInputLink";
import FileUploadComponent from "./template-components/FileUploadComponent";
import { isEqual } from "lodash";
import DraggableArea from "../../features/common/component/DraggableArea";
import DraggableItem from "../../features/common/component/DraggableItem";
import DropZone from "../../features/common/component/DropZone";
import CompositeComponent from "./template-components/CompositeComponent";
import ToggleDisplay from "../../features/common/component/ToggleDisplay";
import SelectApplicationType from "./SelectApplicationType";
import classNames from "classnames";
export default function ApplicationTemplate() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { templateUuid } = useParams();
    const smallTextRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { organizationList, applicationTemplateList, applicationTemplateComponentsList, applicationTemplate, isFetchingData, ariaMoveText, blockMovement, } = useSelector(applicationSelector);
    const [titleError, setTitleError] = useState(false);
    const [duplicateTitleError, setDuplicateTitleError] = useState(false);
    const [organizationError, setOrganizationError] = useState(false);
    const [enteredTitle, setEnteredTitle] = useState("");
    const [organizationUuid, setOrganizationUuid] = useState("");
    const [organization, setOrganization] = useState({
        uuid: "",
        title: "none",
    });
    const [insertComponent, setInsertComponent] = useState(false);
    const [previewTemplate, setPreviewTemplate] = useState(false);
    const [openDiscardModal, setOpenDiscardModal] = useState(false);
    const [focusId, setFocusId] = useState("");
    const [draggedItem, setDraggedItem] = useState("");
    const [draggedEnterItem, setDraggedEnterItem] = useState("");
    const [isDragStarted, setIsDragStarted] = useState(false);
    const [category, setCategory] = useState("");
    const [keysDraggedEnterItem, setKeysDraggedEnterItem] = useState("");
    const [isElementReoderUsingKeyboard, setIsElementReoderUsingKeyboard] = useState(false);
    const [enableLiveRegion, setEnableLiveRegion] = useState(false);
    const [liveAriaObject, setLiveAriaObject] = useState({});
    const inputRef = useRef();
    const [componentPosition, setComponentPosition] = useState(0);
    const [selectedComponent, setSelectedComponent] = useState();
    const [openDeleteFileModal, setOpenDeleteFileModal] = useState(false);
    let [isContentModified, setIsContentModified] = useState(false);
    let currentTemplateObj = (_a = location.state) === null || _a === void 0 ? void 0 : _a.templateObj;
    let currentTemplateComponentList = currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.templateComponentList;
    let isTemplateCopyClicked = (_b = location.state) === null || _b === void 0 ? void 0 : _b.isTemplateCopyClicked;
    let associatedTemplateCount = (_c = location.state) === null || _c === void 0 ? void 0 : _c.associatedTemplateCount;
    document.title =
        (!isNullOrEmpty(templateUuid)
            ? "Edit"
            : isTemplateCopyClicked
                ? "Copy"
                : "Create") + " Application Template | Watermark";
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [distributeNow, setDistributeNow] = useState(false);
    const [openApplicationSelection, setOpenApplicationSelection] = useState(false);
    const organizationLabel = useIntl().formatMessage({
        id: "app.programApplications.organization.dropdown.label",
    });
    const templateTitlelabel = useIntl().formatMessage({
        id: "app.programApplications.template.title.label",
    });
    const templateTitleError = useIntl().formatMessage({
        id: "app.programApplications.template.title.error.message",
    });
    const templateOrganizationError = useIntl().formatMessage({
        id: "app.programApplications.template.organization.error.message",
    });
    const templateDuplicateTitleError = useIntl().formatMessage({
        id: "app.programApplications.template.duplicate.title.error.message",
    });
    const discardModalContent = useIntl().formatMessage({
        id: "app.programApplications.template.discardModal.content",
    });
    const discardModalHeading = useIntl().formatMessage({
        id: "app.programApplications.template.discardModal.heading",
    });
    const discardPrimaryText = useIntl().formatMessage({
        id: "app.programApplications.template.discardModal.primaryText",
    });
    const discardSecondaryText = useIntl().formatMessage({
        id: "app.programApplications.template.discardModal.secondayText",
    });
    const discardModalAriaLabelValue = useIntl().formatMessage({
        id: "app.requirement.discardModal.ariaLabelValue",
    });
    const modalTemplate = useIntl().formatMessage({
        id: "app.programApplications.template.modal",
    });
    const deleteModalInfo = useIntl().formatMessage({
        id: "app.programApplications.template.component.delete.info",
    });
    const deleteModalLabel = useIntl().formatMessage({
        id: "app.programApplications.template.component.delete.label",
    });
    const deleteModalHeading = useIntl().formatMessage({
        id: "app.programApplications.template.component.delete.heading",
    });
    const distributeLaterText = useIntl().formatMessage({
        id: "app.programApplications.template.distribute.later.btn",
    });
    const distributeNowText = useIntl().formatMessage({
        id: "app.programApplications.template.distribute.now.btn",
    });
    const distributeModalHeadingText = useIntl().formatMessage({
        id: "app.programApplications.template.distribute.modal.heading",
    });
    const distributeModalContentText = useIntl().formatMessage({
        id: "app.programApplications.template.distribute.modal.content",
    });
    const modalHeadingText = useIntl().formatMessage({
        id: "app.programApplications.template.information.modal.heading",
    });
    const modalContentText = useIntl().formatMessage({
        id: "app.programApplications.template.information.modal.content",
    });
    const moveText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.moveText",
    });
    const movedToPosition = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.movedToPosition",
    });
    const elementReleased = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.elementReleased",
    });
    const showStdFieldsLabel = useIntl().formatMessage({
        id: "app.programApplications.template.standard.template.fields.toggle.view.text",
    }, {
        toggleValue: "Show",
    });
    const hideStdFieldsLabel = useIntl().formatMessage({
        id: "app.programApplications.template.standard.template.fields.toggle.view.text",
    }, {
        toggleValue: "Hide",
    });
    const grabAriaText = useIntl().formatMessage({
        id: "app.programApplications.drag.drop.component.grab.text",
    }, {
        componentType: (_d = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _d === void 0 ? void 0 : _d.componentType,
        componentLabel: isNullOrEmpty((_e = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _e === void 0 ? void 0 : _e.componentLabel)
            ? (_f = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _f === void 0 ? void 0 : _f.inputText
            : (_g = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _g === void 0 ? void 0 : _g.componentLabel,
    });
    const dropAriaText = useIntl().formatMessage({
        id: "app.programApplications.drag.drop.component.drop.text",
    }, {
        componentType: (_h = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _h === void 0 ? void 0 : _h.componentType,
        componentLabel: isNullOrEmpty((_j = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _j === void 0 ? void 0 : _j.componentLabel)
            ? (_k = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _k === void 0 ? void 0 : _k.inputText
            : (_l = liveAriaObject === null || liveAriaObject === void 0 ? void 0 : liveAriaObject.component) === null || _l === void 0 ? void 0 : _l.componentLabel,
    });
    let errorCount;
    useEffect(() => {
        dispatch(getOrganizationAndChildOrganizations());
    }, []);
    useEffect(() => {
        var _a;
        if (titleError || duplicateTitleError) {
            (_a = document.getElementById("input-template")) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [titleError, duplicateTitleError]);
    useEffect(() => {
        if (organization.title != "none") {
            setOrganizationError(false);
        }
    }, [organization]);
    useEffect(() => {
        var _a;
        dispatch(setIsEditComponentClicked(false));
        if (!(((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.previousPage) === "fromCreateBtn")) {
            dispatch(resetApplicationTemplateComponentsList(currentTemplateComponentList));
        }
        else {
            if ((applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) <= 0) {
                dispatch(setComponentDetails({
                    componentType: "DEFAULT_COMPONENT",
                    inputText: "Standard Template Fields",
                    sortOrder: 0,
                    componentCategory: "STUDENT_INPUT",
                    componentLabel: "",
                    contentLimit: 0,
                    attachedFiles: [],
                    deletedFiles: [],
                    files: [],
                    componentOptionList: [],
                    isMandatory: false,
                    smallTextType: "",
                }));
            }
        }
    }, [currentTemplateObj]);
    useEffect(() => {
        var _a, _b;
        if (currentTemplateObj) {
            let newTempTitle = "Copy " +
                ++associatedTemplateCount +
                " of " +
                (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.title);
            if (newTempTitle.length > 100) {
                newTempTitle = newTempTitle.substring(0, 100);
            }
            if (isTemplateCopyClicked) {
                setEnteredTitle(newTempTitle);
            }
            else {
                setEnteredTitle(currentTemplateObj.title);
                setOrganization({
                    uuid: (_a = currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.organizationObj) === null || _a === void 0 ? void 0 : _a.uuid,
                    title: (_b = currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.organizationObj) === null || _b === void 0 ? void 0 : _b.title,
                });
            }
        }
        else {
            setEnteredTitle("");
        }
    }, [currentTemplateObj]);
    useEffect(() => {
        if ((!insertComponent && focusId !== "") ||
            (!openDeleteFileModal && focusId !== "") ||
            (!setIsEditComponentClicked && focusId !== "")) {
            focusButtonComponent(focusId);
        }
    }, [insertComponent, openDeleteFileModal, setIsEditComponentClicked]);
    useEffect(() => {
        if (currentTemplateObj) {
            applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.forEach((element) => {
                var _a;
                if (((_a = currentTemplateObj.templateComponentList) === null || _a === void 0 ? void 0 : _a.filter((elem) => isEqual(elem, element)).length) === 0) {
                    setIsContentModified(true);
                }
            });
        }
    }, [applicationTemplateComponentsList]);
    const CloseTemplateCreation = () => {
        var _a, _b, _c, _d;
        if (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.uuid) {
            if (isContentModified ||
                organization.uuid !== currentTemplateObj.organizationUuid ||
                applicationTemplateComponentsList.length !==
                    ((_a = currentTemplateObj.templateComponentList) === null || _a === void 0 ? void 0 : _a.length)) {
                setOpenDiscardModal(true);
            }
            else {
                navigate({ pathname: "/programApplications" }, {
                    state: {
                        templateFilterValues: Object.assign({}, (_b = location.state) === null || _b === void 0 ? void 0 : _b.templateFilterValues),
                        currentTab: "item-2",
                    },
                });
                setTimeout(() => {
                    focusActionMenuComponent("action-menu-" + (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.uuid));
                }, 100);
                dispatch(resetApplicationTemplateComponentsList([]));
                setEnteredTitle("");
                dispatch(setApplicationTemplate({}));
            }
        }
        else if (!currentTemplateObj) {
            if (!((isNullOrEmpty(enteredTitle.trim()) &&
                isNullOrEmpty(organization.uuid)) ||
                isContentModified) ||
                (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) > 0) {
                setOpenDiscardModal(true);
            }
            else {
                navigate({ pathname: "/programApplications" }, {
                    state: {
                        templateFilterValues: Object.assign({}, (_c = location.state) === null || _c === void 0 ? void 0 : _c.templateFilterValues),
                        currentTab: "item-2",
                    },
                });
                setTimeout(() => focusButtonComponent("create-template"), 100);
                dispatch(resetApplicationTemplateComponentsList([]));
                setEnteredTitle("");
                dispatch(setApplicationTemplate({}));
            }
        }
        else {
            navigate({ pathname: "/programApplications" }, {
                state: {
                    templateFilterValues: Object.assign({}, (_d = location.state) === null || _d === void 0 ? void 0 : _d.templateFilterValues),
                    currentTab: "item-2",
                },
            });
            setTimeout(() => focusButtonComponent("create-template"), 100);
            dispatch(resetApplicationTemplateComponentsList([]));
            setEnteredTitle("");
            dispatch(setApplicationTemplate({}));
        }
    };
    const isTitleExist = (title) => {
        if (!isTemplateCopyClicked && (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.uuid)) {
            if (currentTemplateObj.title != enteredTitle) {
                return applicationTemplateList.some((appTemp) => appTemp.template.title == title);
            }
        }
        else {
            return applicationTemplateList.some((appTemp) => appTemp.template.title == title);
        }
    };
    const templateValidation = (errorCount, status) => {
        var _a, _b, _c;
        if (enteredTitle.trim() === "") {
            setTitleError(true);
            errorCount += 1;
            (_a = document.getElementById("input-template")) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            setTitleError(false);
        }
        if (isTitleExist(enteredTitle.trim())) {
            setDuplicateTitleError(true);
            errorCount += 1;
            (_b = document.getElementById("input-template")) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            setDuplicateTitleError(false);
        }
        if (organization.title === "none" || isNullOrEmpty(organization.title)) {
            setOrganizationError(true);
            errorCount += 1;
            if (enteredTitle.trim() !== "" || !isTitleExist(enteredTitle)) {
                (_c = document.getElementById("select-organization")) === null || _c === void 0 ? void 0 : _c.focus();
            }
        }
        else {
            setOrganizationError(false);
        }
        if (((applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) == 0 ||
            (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === undefined) &&
            errorCount == 0 &&
            status !== "DRAFT") {
            setIsOpen(true);
            errorCount += 1;
        }
        return errorCount;
    };
    const navigateToApplicationTemplateTab = (latestCreatedTemplate) => {
        var _a;
        navigate({ pathname: "/programApplications" }, {
            state: {
                templateFilterValues: Object.assign({}, (_a = location.state) === null || _a === void 0 ? void 0 : _a.templateFilterValues),
                currentTab: "item-2",
            },
        });
        setTimeout(() => {
            var _a;
            focusActionMenuComponent("action-menu-" + ((_a = latestCreatedTemplate === null || latestCreatedTemplate === void 0 ? void 0 : latestCreatedTemplate.template) === null || _a === void 0 ? void 0 : _a.uuid));
        }, 200);
    };
    const saveTemplateCreation = (event, status) => __awaiter(this, void 0, void 0, function* () {
        let distNow = status === "PUBLISH DISTRIBUTE NOW";
        event.preventDefault();
        if (isFetchingData)
            return;
        errorCount = 0;
        const updatedCompList = applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.map((comp) => {
            var _a;
            if ((_a = comp.uuid) === null || _a === void 0 ? void 0 : _a.startsWith(comp.componentType)) {
                comp = Object.assign(Object.assign({}, comp), { uuid: "" });
            }
            return comp;
        });
        let templateObj = {
            orgUuid: organization.uuid,
            title: enteredTitle,
            status: status != "DRAFT" ? "PUBLISHED" : status,
            templateComponentList: updatedCompList,
            copiedFromTemplateUuid: currentTemplateObj ? currentTemplateObj.uuid : "",
        };
        errorCount = templateValidation(errorCount, status);
        if (errorCount === 0) {
            if (isNullOrEmpty(isTemplateCopyClicked) && (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.uuid)) {
                let tempObj = {
                    uuid: currentTemplateObj.uuid,
                    orgUuid: organization.uuid,
                    title: enteredTitle,
                    status: status !== "DRAFT" ? "PUBLISHED" : status,
                    templateComponentList: updatedCompList,
                };
                setIsModalOpen(false);
                dispatch(updateTemplate(tempObj)).then(() => {
                    dispatch(getAllApplicationTemplates());
                    if (!distNow)
                        navigateToApplicationTemplateTab(tempObj);
                    else
                        setDistributeNow(distNow);
                });
            }
            else {
                setIsModalOpen(false);
                dispatch(saveTemplate(templateObj)).then((data) => {
                    let latestCreatedTemplate = data.payload;
                    dispatch(getAllApplicationTemplates()).then(() => {
                        if (!distNow)
                            navigateToApplicationTemplateTab(latestCreatedTemplate);
                        else
                            setDistributeNow(distNow);
                    });
                });
            }
        }
    });
    useEffect(() => {
        if (distributeNow) {
            setOpenApplicationSelection(true);
        }
    }, [distributeNow, applicationTemplate]);
    const removeTemplateComponent = (event, position) => {
        event.preventDefault();
        dispatch(removeComponent({ position }));
        setOpenDeleteFileModal(false);
        if (position === 0) {
            setFocusId("delete-btn-comp-" + position.toString());
        }
        else {
            setFocusId("delete-btn-comp-" + (position - 1).toString());
        }
        if ((applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === 1) {
            setFocusId("insert-component");
        }
    };
    const closeDeleteModalHandler = (event) => {
        event.preventDefault();
        setOpenDeleteFileModal(false);
        setFocusId("delete-btn-comp-" + componentPosition.toString());
    };
    const componenetDeleteHandler = (event, position) => {
        event.preventDefault();
        setOpenDeleteFileModal(true);
        setComponentPosition(position);
    };
    const openFlyoutHandler = (event, insertId, position) => {
        setSelectedComponent(undefined);
        setInsertComponent(true);
        setFocusId(insertId);
        setComponentPosition(position);
        dispatch(getAllApplicationComponents());
        dispatch(setIsEditComponentClicked(false));
    };
    const titleHandler = (event) => {
        event.preventDefault();
        if (currentTemplateObj) {
            if (event.target.value !== currentTemplateObj.title) {
                setIsContentModified(true);
            }
        }
        setEnteredTitle(event.target.value);
        if (event.target.value == "") {
            setTitleError(true);
        }
        else {
            setTitleError(false);
        }
        setDuplicateTitleError(false);
    };
    const discardChanges = (event) => __awaiter(this, void 0, void 0, function* () {
        var _m;
        event.preventDefault();
        dispatch(resetApplicationTemplateComponentsList([]));
        navigate({ pathname: "/programApplications" }, {
            state: {
                templateFilterValues: Object.assign({}, (_m = location.state) === null || _m === void 0 ? void 0 : _m.templateFilterValues),
                currentTab: "item-2",
            },
        });
        dispatch(getAllApplicationComponents());
        if (applicationTemplateList) {
            setTimeout(() => {
                if (location.state.previousPage === "fromActionMenu" ||
                    isTemplateCopyClicked) {
                    focusActionMenuComponent("action-menu-" + currentTemplateObj.uuid);
                }
                else {
                    focusButtonComponent("create-template");
                }
            }, 200);
        }
        else {
            setTimeout(() => {
                focusButtonComponent("create-template");
            }, 200);
        }
    });
    const closeDiscardModalHandler = (event) => {
        var _a;
        event.preventDefault();
        setOpenDiscardModal(false);
        (_a = document.getElementById("input-template")) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const editComponentTextHandler = (comp, index) => {
        setSelectedComponent(comp);
        setInsertComponent(true);
        setFocusId("edit-btn-comp-" + index.toString());
        dispatch(setIsEditComponentClicked(true));
        let sortOrder = comp.sortOrder;
        setComponentPosition(sortOrder);
    };
    const closePublishModalHandler = (event) => {
        var _a;
        event.preventDefault();
        setIsModalOpen(false);
        (_a = document.getElementById("publish-btn")) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const closeInfoModalHandler = (event) => {
        var _a, _b;
        event.preventDefault();
        setIsOpen(false);
        if (titleError || duplicateTitleError) {
            (_a = document.getElementById("input-template")) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else if ((!(enteredTitle.trim() === "") || isTitleExist(enteredTitle)) &&
            organizationError) {
            (_b = document.getElementById("select-organization")) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else if (applicationTemplateComponentsList.length == 0) {
            focusButtonComponent("insert-component");
        }
    };
    const openModalToPublish = (event) => __awaiter(this, void 0, void 0, function* () {
        var _o, _p, _q;
        event.preventDefault();
        errorCount = 0;
        if (enteredTitle.trim() === "") {
            setTitleError(true);
            errorCount += 1;
            (_o = document.getElementById("input-template")) === null || _o === void 0 ? void 0 : _o.focus();
        }
        else {
            setTitleError(false);
        }
        if (isTitleExist(enteredTitle)) {
            setDuplicateTitleError(true);
            errorCount += 1;
            (_p = document.getElementById("input-template")) === null || _p === void 0 ? void 0 : _p.focus();
        }
        else {
            setDuplicateTitleError(false);
        }
        if (organization.title === "none") {
            setOrganizationError(true);
            errorCount += 1;
            if (enteredTitle.trim() !== "" || !isTitleExist(enteredTitle)) {
                (_q = document.getElementById("select-organization")) === null || _q === void 0 ? void 0 : _q.focus();
            }
        }
        else {
            setOrganizationError(false);
        }
        if (((applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) == 0 ||
            (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === undefined) &&
            errorCount == 0) {
            setIsOpen(true);
            errorCount += 1;
        }
        if (errorCount == 0) {
            setIsModalOpen(true);
        }
    });
    const renderLiveRegion = () => {
        if (enableLiveRegion) {
            if (isElementReoderUsingKeyboard && liveAriaObject.keyCode === 13) {
                dispatch(setAriaMoveText({ text: grabAriaText }));
            }
            else if (!isElementReoderUsingKeyboard) {
                if (liveAriaObject.keyCode === 27) {
                    dispatch(setAriaMoveText({ text: elementReleased }));
                }
                else if (liveAriaObject.keyCode === 13) {
                    dispatch(setAriaMoveText({ text: dropAriaText }));
                }
            }
        }
        return (_jsx("div", Object.assign({ className: "sr-only", "aria-live": "polite", "aria-atomic": "true" }, { children: ariaMoveText })));
    };
    const dismissDrag = (event) => {
        event.preventDefault();
        event.stopPropagation();
        navigateToElement(draggedItem);
        setDraggedItem("");
        setDraggedEnterItem("");
        hideGhostElement();
        setIsDragStarted(false);
    };
    const hideGhostElement = () => {
        let ghostElement = document.getElementById("ghost-element-container");
        if (ghostElement !== null) {
            ghostElement.style.display = "none";
        }
    };
    const changePosition = (source, dest, insertBefore, emptyNodeIdentifier) => {
        dispatch(placeComponentToNewPosition({
            source,
            dest,
            insertBefore,
            emptyNodeIdentifier,
        }));
        setDraggedItem("");
        setDraggedEnterItem("");
        setKeysDraggedEnterItem("");
        setIsDragStarted(false);
        setCategory("");
    };
    useEffect(() => {
        let element = document.getElementById("drag-icon-" + keysDraggedEnterItem);
        if (element)
            element.focus();
    }, [applicationTemplateComponentsList]);
    const changePositionViaKeyboard = (source, keyCode, component) => __awaiter(this, void 0, void 0, function* () {
        if (!blockMovement) {
            yield Promise.all([
                dispatch(setBlockMovement({ val: true })),
                dispatch(placeComponentToNewPositionKeyboard({
                    source,
                    keyCode,
                    movedToPosition,
                    component,
                })),
            ]);
            setDraggedItem("");
        }
    });
    const keyDownHandler = (event, component) => {
        var _a;
        let compTitle = isNullOrEmpty(component === null || component === void 0 ? void 0 : component.componentLabel)
            ? component === null || component === void 0 ? void 0 : component.inputText
            : component === null || component === void 0 ? void 0 : component.componentLabel;
        let compUuid = isNullOrEmpty(component === null || component === void 0 ? void 0 : component.uuid)
            ? (component === null || component === void 0 ? void 0 : component.componentType) + compTitle + (component === null || component === void 0 ? void 0 : component.sortOrder)
            : component.uuid;
        const keyCode = event.keyCode ? event.keyCode : event.which;
        if (!(keyCode === 9 && !isElementReoderUsingKeyboard)) {
            event.preventDefault();
        }
        if (keyCode === 13) {
            // enter click
            dispatch(setComponentsListData({ reset: false }));
            if (isElementReoderUsingKeyboard) {
                // commit Changes
                setIsElementReoderUsingKeyboard(false);
                setKeysDraggedEnterItem("");
                setLiveAriaObject({ component, keyCode });
            }
            else {
                setIsElementReoderUsingKeyboard(true);
                setEnableLiveRegion(true);
                setKeysDraggedEnterItem(compUuid);
                setLiveAriaObject({ component, keyCode });
            }
            setTimeout(() => {
                var _a;
                (_a = document.getElementById("drag-icon-" + compUuid)) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
        else if (keyCode === 40 || keyCode === 38) {
            // up/down key
            if (isElementReoderUsingKeyboard) {
                setLiveAriaObject({ component, keyCode });
                changePositionViaKeyboard(keysDraggedEnterItem, keyCode, component);
            }
        }
        else if (keyCode === 9) {
            // Tab key
            if (isElementReoderUsingKeyboard) {
                (_a = document.getElementById("drag-icon-" + compUuid)) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                return;
            }
        }
        else if (keyCode === 27) {
            // Esc key
            setLiveAriaObject({ component, keyCode });
            setIsElementReoderUsingKeyboard(false);
            dispatch(setComponentsListData({ reset: true }));
            setKeysDraggedEnterItem("");
            setTimeout(() => {
                var _a;
                (_a = document.getElementById("drag-icon-" + compUuid)) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
    };
    const renderStandardTemplateFields = (comp) => {
        const compUuid = isNullOrEmpty(comp === null || comp === void 0 ? void 0 : comp.uuid)
            ? (comp === null || comp === void 0 ? void 0 : comp.componentType) +
                (isNullOrEmpty(comp === null || comp === void 0 ? void 0 : comp.componentLabel)
                    ? comp === null || comp === void 0 ? void 0 : comp.inputText
                    : comp === null || comp === void 0 ? void 0 : comp.componentLabel) +
                (comp === null || comp === void 0 ? void 0 : comp.sortOrder)
            : comp === null || comp === void 0 ? void 0 : comp.uuid;
        const disableDragIcon = (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === 1 &&
            (comp === null || comp === void 0 ? void 0 : comp.componentType) === "DEFAULT_COMPONENT";
        return (_jsxs("div", Object.assign({ className: `paper-card card-component standard-components-card`, tabIndex: 0 }, { children: [_jsxs("div", Object.assign({ className: "card-header flex-row -justified -verticallycentered" }, { children: [_jsx("div", Object.assign({ id: `drag-icon-${compUuid}`, className: `drag-svg-section ${!disableDragIcon ? "enable" : ""}`, tabIndex: 0, role: "button", "aria-label": moveText +
                                " " +
                                "comp.componentType" +
                                " " +
                                (isNullOrEmpty(comp === null || comp === void 0 ? void 0 : comp.componentLabel)
                                    ? comp === null || comp === void 0 ? void 0 : comp.inputText
                                    : comp === null || comp === void 0 ? void 0 : comp.componentLabel), onKeyDown: (event) => keyDownHandler(event, comp) }, { children: _jsxs("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("title", { children: "Drag & Drop" }), _jsx("g", Object.assign({ id: "UX:-Drag-&amp;-Drop_" + compUuid, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: _jsx("g", Object.assign({ id: "Section---Drag-&amp;-Drop-State_" + compUuid, transform: "translate(-366.000000, -446.000000)" }, { children: _jsxs("g", Object.assign({ id: "Drag-&amp;-Drop-Icon_" + compUuid, transform: "translate(366.000000, 446.000000)" }, { children: [_jsx("polygon", { id: "Path_" + compUuid, points: "0 0 24 0 24 24 0 24" }), _jsx("path", { d: "M11,18 C11,19.1 10.1,20 9,20 C7.9,20 7,19.1 7,18 C7,16.9 7.9,16 9,16 C10.1,16 11,16.9 11,18 Z M9,10 C7.9,10 7,10.9 7,12 C7,13.1 7.9,14 9,14 C10.1,14 11,13.1 11,12 C11,10.9 10.1,10 9,10 Z M9,4 C7.9,4 7,4.9 7,6 C7,7.1 7.9,8 9,8 C10.1,8 11,7.1 11,6 C11,4.9 10.1,4 9,4 Z M15,8 C16.1,8 17,7.1 17,6 C17,4.9 16.1,4 15,4 C13.9,4 13,4.9 13,6 C13,7.1 13.9,8 15,8 Z M15,10 C13.9,10 13,10.9 13,12 C13,13.1 13.9,14 15,14 C16.1,14 17,13.1 17,12 C17,10.9 16.1,10 15,10 Z M15,16 C13.9,16 13,16.9 13,18 C13,19.1 13.9,20 15,20 C16.1,20 17,19.1 17,18 C17,16.9 16.1,16 15,16 Z", id: "Shape_" + compUuid, fill: "#6B6B6B", fillRule: "nonzero" })] })) })) }))] })) })), _jsxs("div", Object.assign({ className: "header-body" }, { children: [_jsx("h2", Object.assign({ className: "header-title" }, { children: !isNullOrEmpty(comp === null || comp === void 0 ? void 0 : comp.inputText)
                                        ? comp === null || comp === void 0 ? void 0 : comp.inputText
                                        : translate("app.programApplications.template.standard.template.fields") })), _jsx("p", Object.assign({ className: "header-info" }, { children: translate("app.programApplications.template.standard.template.fields.info") }))] }))] })), _jsx("div", Object.assign({ className: "card-body" }, { children: _jsx(_Fragment, { children: _jsx(ToggleDisplay, Object.assign({ toggleBtnId: "std-template-fields-toggle", showLabel: showStdFieldsLabel, hideLabel: hideStdFieldsLabel }, { children: _jsx(CompositeComponent, { appTemplateView: true, isExternal: false }) })) }) }))] })));
    };
    const mainContent = () => {
        var _a;
        let addDropZone = false;
        let addToNextElem = false;
        let compTitle = "";
        let compUuid = "";
        return (_jsx(_Fragment, { children: ((applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === 1 &&
                ((_a = applicationTemplateComponentsList[0]) === null || _a === void 0 ? void 0 : _a.componentType) ===
                    "DEFAULT_COMPONENT") ||
                (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === undefined ||
                (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) === 0 ? (_jsxs("div", Object.assign({ className: "main-template-panel" }, { children: [renderStandardTemplateFields(applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList[0]), _jsx("div", Object.assign({ className: "insert-text" }, { children: translate("app.programApplications.insert.component.desc") })), _jsx("div", Object.assign({ className: "insert-component-btn" }, { children: _jsx(WmButton, Object.assign({ id: "insert-component", buttonType: "secondary", icon: "f419", onClick: (event) => openFlyoutHandler(event, "insert-btn-0", applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length), placeholder: undefined }, { children: translate("app.programApplications.insert.component.btn") })) }))] }))) : (_jsx("div", Object.assign({ className: "main-template-panel list-components" }, { children: _jsxs("div", Object.assign({ className: "components-container" }, { children: [_jsx("div", Object.assign({ className: "btn-line", onClick: (event) => openFlyoutHandler(event, "insert-btn-0", 0) }, { children: _jsx(WmButton, { buttonType: "navigational", icon: "F419", id: "insert-btn-top", class: "btn-backgrd", tooltip: "Insert Component", "tooltip-position": "right", placeholder: undefined }) })), applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.map((comp, index) => {
                            var _a, _b, _c, _d;
                            addDropZone = false;
                            compTitle = isNullOrEmpty(comp.componentLabel)
                                ? comp.inputText
                                : comp.componentLabel;
                            compUuid = isNullOrEmpty(comp.uuid)
                                ? comp.componentType + compTitle + comp.sortOrder
                                : comp.uuid;
                            if ((index === 0 && compUuid !== draggedItem) ||
                                addToNextElem) {
                                addDropZone = true;
                                addToNextElem = false;
                            }
                            else if (index === 0 && compUuid === draggedItem) {
                                addToNextElem = true;
                            }
                            else if (index === 0) {
                                addToNextElem = true;
                            }
                            return (_jsxs("div", Object.assign({ id: "comp-" + index.toString() }, { children: [addDropZone && isDragStarted ? (_jsx(DropZone, Object.assign({ nodeId: "section-top", nodeIdentifier: "section-outline", elements: 0, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, isDragStarted: isDragStarted, category: category, height: "10px" }, { children: "" }))) : (""), _jsx(DraggableItem, Object.assign({ object: {
                                            uuid: isElementReoderUsingKeyboard
                                                ? compUuid
                                                : (_a = comp === null || comp === void 0 ? void 0 : comp.sortOrder) === null || _a === void 0 ? void 0 : _a.toString(),
                                            title: compTitle,
                                        }, draggedItem: draggedItem, setDraggedItem: setDraggedItem, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, index: index, isDragStarted: isDragStarted, setIsDragStarted: setIsDragStarted, categoryType: "section", setCategory: setCategory, category: category, isElementReoderUsingKeyboard: isElementReoderUsingKeyboard, keysDraggedEnterItem: keysDraggedEnterItem }, { children: comp.componentType === "DEFAULT_COMPONENT" ? (renderStandardTemplateFields(comp)) : (_jsxs("div", Object.assign({ className: "paper-card component-card flex-row" }, { children: [_jsx("div", Object.assign({ id: `drag-icon-${compUuid}`, className: "drag-svg-section", tabIndex: 0, role: "button", "aria-label": moveText +
                                                        " " +
                                                        comp.componentType +
                                                        " " +
                                                        compTitle, onKeyDown: (event) => keyDownHandler(event, comp) }, { children: _jsxs("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("title", { children: "Drag & Drop" }), _jsx("g", Object.assign({ id: "UX:-Drag-&amp;-Drop_" + compUuid, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: _jsx("g", Object.assign({ id: "Section---Drag-&amp;-Drop-State_" +
                                                                        compUuid, transform: "translate(-366.000000, -446.000000)" }, { children: _jsxs("g", Object.assign({ id: "Drag-&amp;-Drop-Icon_" + compUuid, transform: "translate(366.000000, 446.000000)" }, { children: [_jsx("polygon", { id: "Path_" + compUuid, points: "0 0 24 0 24 24 0 24" }), _jsx("path", { d: "M11,18 C11,19.1 10.1,20 9,20 C7.9,20 7,19.1 7,18 C7,16.9 7.9,16 9,16 C10.1,16 11,16.9 11,18 Z M9,10 C7.9,10 7,10.9 7,12 C7,13.1 7.9,14 9,14 C10.1,14 11,13.1 11,12 C11,10.9 10.1,10 9,10 Z M9,4 C7.9,4 7,4.9 7,6 C7,7.1 7.9,8 9,8 C10.1,8 11,7.1 11,6 C11,4.9 10.1,4 9,4 Z M15,8 C16.1,8 17,7.1 17,6 C17,4.9 16.1,4 15,4 C13.9,4 13,4.9 13,6 C13,7.1 13.9,8 15,8 Z M15,10 C13.9,10 13,10.9 13,12 C13,13.1 13.9,14 15,14 C16.1,14 17,13.1 17,12 C17,10.9 16.1,10 15,10 Z M15,16 C13.9,16 13,16.9 13,18 C13,19.1 13.9,20 15,20 C16.1,20 17,19.1 17,18 C17,16.9 16.1,16 15,16 Z", id: "Shape_" + compUuid, fill: "#6B6B6B", fillRule: "nonzero" })] })) })) }))] })) })), _jsx("div", Object.assign({ className: `component-body comp-${comp.componentType.toLowerCase()}`, id: "comp-body-" + index.toString() }, { children: comp.componentType === "SECTION_HEADER" ? (_jsx("h3", Object.assign({ className: "section-header-style" }, { children: comp === null || comp === void 0 ? void 0 : comp.inputText }))) : comp.componentType === "TEXT" ? (_jsx("span", { children: comp === null || comp === void 0 ? void 0 : comp.inputText })) : comp.componentType === "SMALL_TEXT_FIELD" ? (_jsx(Inputfield, { titleError: false, dataLabel: comp.inputText, modalTitle: "", updateTitleHandler: () => { }, inputRef: smallTextRef, modalFor: comp.inputText, placeholder: comp.smallTextType == "PHONE_NUMBER"
                                                            ? "123-456-7890"
                                                            : "", modalId: getIdByKey(comp.componentType, TemplateComponentList) + index.toString(), disabled: true, required: comp.isMandatory })) : comp.componentType === "LINK_RESOURCE" ? (_jsx(ResourceLink, { id: "template-" + index.toString(), url: comp.inputText, displayText: comp.componentLabel, appTemplateView: true })) : comp.componentType === "LARGE_TEXT_AREA" ? (_jsxs("div", Object.assign({ className: "text-area-field" }, { children: [_jsx("label", Object.assign({ className: classNames("textfieldlabel", comp.isMandatory && "required"), htmlFor: getIdByKey(comp.componentType, TemplateComponentList) + index.toString() }, { children: comp.inputText })), _jsx("textarea", { className: "textfieldinput", id: getIdByKey(comp.componentType, TemplateComponentList) + index.toString(), value: "", onChange: () => { }, disabled: true, required: comp.isMandatory })] }))) : comp.componentType === "ATTACHMENT" ? (_jsx(ResourceAttachment, { id: "template-" + index.toString(), attachedFilesList: getUploaderFiles(comp), displayLabel: comp.componentLabel, appTemplateView: true, files: comp.files })) : comp.componentType === "LINK_INPUT" ? (_jsx(StudentInputLink, { id: "appTemp-" + index.toString(), componentId: getIdByKey(comp.componentType, TemplateComponentList), displayLabel: comp.inputText, appTemplateView: true, isMandatory: comp.isMandatory })) : comp.componentType === "FILE_UPLOAD" ? (_jsx(FileUploadComponent, { id: "file-upload-component" + index, componentObj: comp, isStudentView: false, isEditable: true })) : comp.componentType === "DROPDOWN" ? (_jsxs(_Fragment, { children: [_jsx("label", Object.assign({ htmlFor: "select-dropdown" + index.toString(), className: "dropdown-label" }, { children: comp.componentLabel })), comp.isMandatory && (_jsx("span", Object.assign({ className: "reqd" }, { children: `  *` }))), _jsxs(WmSelect, Object.assign({ label: comp.componentLabel, labelPosition: "none", requiredField: comp.isMandatory, id: "select-dropdown" + index.toString(), placeholder: undefined }, { children: [_jsx(WmOption, Object.assign({ id: "option-" + index + "-SelectOption", selected: true, placeholder: undefined }, { children: translate("app.programApplications.select.option") }), "empty"), (_b = comp.componentOptionList) === null || _b === void 0 ? void 0 : _b.map((option) => (_jsx(WmOption, Object.assign({ id: `option-${index}-${option.sortOrder}`, placeholder: undefined }, { children: option.text }), "option" +
                                                                        option.sortOrder +
                                                                        option.text)))] }), "select" + applicationTemplateComponentsList)] })) : comp.componentType ===
                                                        "MULTISELECT_CHECKBOXES" ? (_jsxs("div", Object.assign({ className: "multiselect-checkbox-component" }, { children: [_jsxs("label", Object.assign({ className: "app-component-label" }, { children: [comp.componentLabel, comp.isMandatory && (_jsx("span", Object.assign({ className: "reqd" }, { children: "*" })))] })), _jsx("p", Object.assign({ className: "checkbox-info-msg" }, { children: translate("app.programApplications.component.multiselect.checkboxes.select.text") })), comp.componentOptionList.length > 0 &&
                                                                ((_c = comp.componentOptionList) === null || _c === void 0 ? void 0 : _c.map((option) => (_jsxs("div", Object.assign({ className: "checkbox-option" }, { children: [_jsx("input", { type: "checkbox", className: "chkbx-input", id: `chkbx-option-${index}-${option.sortOrder}`, disabled: true }), _jsx("label", Object.assign({ className: "chkbx", htmlFor: `chkbx-option-${index}-${option.sortOrder}` }, { children: option.text }))] }), `chkbx-${index}-${option.sortOrder}`))))] }))) : comp.componentType ===
                                                        "ACKNOWLEDGEMENT_CHECKBOX" ? (_jsxs("div", Object.assign({ className: "acknowledgement-checkbox-component" }, { children: [_jsxs("label", Object.assign({ className: "app-component-label" }, { children: [comp.componentLabel, comp.isMandatory && comp.componentLabel && (_jsx("span", Object.assign({ className: "reqd" }, { children: "*" })))] })), _jsxs("div", Object.assign({ className: "checkbox-option" }, { children: [_jsx("input", { type: "checkbox", className: "chkbx-input", id: `ack-checkbox-${index}`, disabled: true }), _jsx("label", Object.assign({ className: "chkbx", htmlFor: `ack-checkbox-${index}` }, { children: _jsxs("div", Object.assign({ className: "ack-label" }, { children: [comp.inputText, comp.isMandatory &&
                                                                                    isNullOrEmpty(comp.componentLabel) && (_jsx("span", Object.assign({ className: "reqd" }, { children: "*" })))] })) }))] }), `chkbx-${index}`)] }))) : comp.componentType === "DATE_SELECTOR" ? (_jsxs("div", { children: [_jsxs("label", Object.assign({ className: "date-picker-label", htmlFor: "date-selector" + index }, { children: [comp.inputText, comp.isMandatory && (_jsx("span", Object.assign({ className: "reqd" }, { children: `  *` })))] })), _jsx(WmDatepicker, { id: "date-selector" + index, label: comp.inputText, labelPosition: "none", dateFormat: "mm/dd/yyyy", disabled: true, placeholder: undefined })] })) : comp.componentType === "RADIO_BUTTON" ? (_jsxs("div", Object.assign({ className: "radio-button-component" }, { children: [_jsxs("label", Object.assign({ className: "app-component-label" }, { children: [comp.componentLabel, comp.isMandatory && (_jsx("span", Object.assign({ className: "reqd" }, { children: "*" })))] })), comp.componentOptionList.length > 0 &&
                                                                ((_d = comp.componentOptionList) === null || _d === void 0 ? void 0 : _d.map((option) => (_jsxs("div", Object.assign({ className: "radio-cell" }, { children: [_jsx("input", { type: "radio", name: "radio_button" + index, id: `radio-option-${index}-${option.sortOrder}`, value: option.uuid, className: "radio-input", disabled: true }), _jsx("label", Object.assign({ htmlFor: `radio-option-${index}-${option.sortOrder}`, className: "radio" }, { children: option.text }))] }), `radio-${index}-${option.sortOrder}`))))] }))) : (_jsx(_Fragment, {})) })), _jsxs("div", Object.assign({ className: "component-update-btns" }, { children: [_jsx(WmButton, { className: "edit-component-btn", buttonType: "icononly", icon: "F3EB", id: "edit-btn-comp-" + index.toString(), tooltip: "Edit Component", "tooltip-position": "right", onClick: () => editComponentTextHandler(comp, index), placeholder: undefined }), _jsx(WmButton, { buttonType: "icononly", icon: "F1C0", id: "delete-btn-comp-" + index.toString(), tooltip: "Delete Component", "tooltip-position": "right", onClick: (event) => {
                                                                componenetDeleteHandler(event, index);
                                                            }, placeholder: undefined })] }))] }))) }), compUuid), _jsx("div", Object.assign({ className: "btn-line", onClick: (event) => openFlyoutHandler(event, "insert-btn-" + (index + 1).toString(), index + 1) }, { children: _jsx(WmButton, { buttonType: "navigational", icon: "F419", class: "btn-backgrd", id: "insert-btn-" + index.toString(), tooltip: "Insert Component", "tooltip-position": "right", placeholder: undefined }) }))] }), index.toString()));
                        })] })) }))) }));
    };
    const subHeaderContent = () => {
        return (_jsxs("div", Object.assign({ className: "flex-row -justified -verticallycentered template-fields" }, { children: [_jsx("div", Object.assign({ className: "template-title" }, { children: _jsx(Inputfield, { titleError: titleError || duplicateTitleError, dataLabel: `${templateTitlelabel} `, modalTitle: enteredTitle, updateTitleHandler: titleHandler, inputRef: inputRef, modalFor: modalTemplate, modalId: modalTemplate, required: true, customError: true, customErrorMessage: titleError
                            ? templateTitleError
                            : duplicateTitleError
                                ? templateDuplicateTitleError
                                : "" }) })), _jsxs(WmSelect, Object.assign({ label: `${organizationLabel} `, requiredField: true, className: "select-org", id: "select-organization", errorMessage: organizationError ? templateOrganizationError : "", disabled: (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.status) === "PUBLISHED" &&
                        (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.studentSubmissionsExist) &&
                        !isTemplateCopyClicked, placeholder: undefined }, { children: [_jsx(WmOption, Object.assign({ role: "option", "aria-label": "All", id: "option-SelectOption", selected: organization.title === "none", onWmOptionSelected: (event) => setOrganization({ uuid: "", title: "none" }), placeholder: undefined }, { children: translate("app.programApplications.select.option") }), "option-none"), organizationList.length > 0
                            ? organizationList.map((org) => {
                                return (_jsx(WmOption, Object.assign({ role: "option", id: "option-" + org.uuid, "aria-label": org.title, onWmOptionSelected: (event) => {
                                        setOrganization({ uuid: org.uuid, title: org.title });
                                        setOrganizationError(false);
                                        setOrganizationUuid(org.uuid);
                                    }, selected: organization.uuid === org.uuid, placeholder: undefined }, { children: org.title }), "option" + org.uuid));
                            })
                            : null] }), "select" + organization.uuid), (applicationTemplateComponentsList === null || applicationTemplateComponentsList === void 0 ? void 0 : applicationTemplateComponentsList.length) > 0 ? (_jsx(WmButton, Object.assign({ className: "preview-template-btn", "button-type": "textonly", icon: "f208", onClick: () => {
                        setPreviewTemplate(true);
                    }, placeholder: undefined }, { children: translate("app.programApplications.preview.template.label") }))) : null] })));
    };
    return isFetchingData ? (_jsx("div", Object.assign({ className: "loader -fullscreen" }, { children: _jsx("div", Object.assign({ className: "content content-loader", role: "alert" }, { children: "Loading..." })) }))) : openApplicationSelection ? (_jsx(SelectApplicationType, { isOpen: true, type: "FLYOUT", closeModal: () => {
            navigate({ pathname: "/programApplications" }, {
                state: {
                    currentTab: "item-1",
                },
            });
        }, primaryClick: (type) => {
            navigate({
                pathname: "/programApplications/distribute",
                search: `?org_uuid=${applicationTemplate.organizationUuid}&template_uuid=${applicationTemplate.uuid}`,
            }, {
                state: {
                    selectedApplicationType: type,
                },
            });
        } })) : (_jsxs("main", Object.assign({ className: "application-template-view" }, { children: [_jsxs(DraggableArea, Object.assign({ dismissDrag: dismissDrag, category: "template" }, { children: [_jsxs("section", Object.assign({ className: "paper-card flex-row -justified -verticallycentered create-template-header" }, { children: [_jsxs("div", Object.assign({ className: "flex-row -justified -verticallycentered" }, { children: [_jsx(WmButton, { id: "close-template-btn", buttonType: "navigational", icon: "f156", class: "cancel hydrated", onClick: CloseTemplateCreation, tooltip: "Close", placeholder: undefined }), !(templateUuid == null || templateUuid == "") ? (_jsxs("div", Object.assign({ className: "heading-content" }, { children: [_jsx("h1", Object.assign({ className: "header-title" }, { children: translate("app.programApplications.header.edit.title") })), _jsxs("div", Object.assign({ className: "required-fields" }, { children: [translate("app.cohort.requiredText.prefix"), _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), translate("app.cohort.requiredText.suffix")] }))] }))) : (_jsxs("div", Object.assign({ className: "heading-content" }, { children: [_jsx("h1", Object.assign({ className: "header-title" }, { children: translate("app.programApplications.header.title", {
                                                    action: isTemplateCopyClicked ? "Copy" : "Create",
                                                }) })), _jsxs("div", Object.assign({ className: "required-fields" }, { children: [translate("app.cohort.requiredText.prefix"), _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), translate("app.cohort.requiredText.suffix")] }))] })))] })), _jsx("div", Object.assign({ className: "flex-row -justified -verticallycentered" }, { children: templateUuid ? (_jsxs("div", { children: [_jsx(WmButton, Object.assign({ buttonType: (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.status) !== "PUBLISHED"
                                                ? "secondary"
                                                : "primary", id: "update-btn", onClick: (event) => saveTemplateCreation(event, (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.status)
                                                ? currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.status
                                                : "DRAFT"), placeholder: undefined }, { children: translate("app.programApplications.update.btn") })), (currentTemplateObj === null || currentTemplateObj === void 0 ? void 0 : currentTemplateObj.status) !== "PUBLISHED" && (_jsx(WmButton, Object.assign({ buttonType: "primary", id: "publish-btn", onClick: (event) => openModalToPublish(event), placeholder: undefined }, { children: translate("app.programApplications.publish.btn") })))] })) : (_jsxs("div", { children: [_jsx(WmButton, Object.assign({ buttonType: "secondary", id: "save-as-draft-btn", onClick: (event) => saveTemplateCreation(event, "DRAFT"), placeholder: undefined }, { children: translate("app.programApplications.saveAsDraft.btn") })), _jsx(WmButton, Object.assign({ buttonType: "primary", id: "publish-btn", onClick: (event) => openModalToPublish(event), placeholder: undefined }, { children: translate("app.programApplications.publish.btn") }))] })) }))] })), _jsxs("section", Object.assign({ className: "immersive-container" }, { children: [_jsx("div", Object.assign({ className: "paper-card flex-row -justified -verticallycentered template-subheader" }, { children: subHeaderContent() })), _jsx("div", Object.assign({ className: "template-main-content", role: "application" }, { children: mainContent() }))] })), renderLiveRegion()] })), _jsx("div", { className: "sr-only", id: "dialog-wrapper-top", tabIndex: 0 }), insertComponent ? (_jsx(InsertComponent, { setInsertComponent: setInsertComponent, sortOrder: componentPosition, componentObj: selectedComponent, flyoutMode: (selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.inputText) == null
                    ? "chooseComponent"
                    : "componentSettings" })) : null, previewTemplate ? (_jsx(PreviewTemplate, { setPreviewTemplate: setPreviewTemplate, templateTitle: enteredTitle, fromViewTemplate: false })) : null, _jsx(DiscardModal, { isOpen: openDiscardModal, onPrimaryClick: (event) => discardChanges(event), onSecondaryClick: (event) => closeDiscardModalHandler(event), onClose: (event) => closeDiscardModalHandler(event), modalContent: discardModalContent, modalHeading: discardModalHeading, ariaLabelValue: discardModalAriaLabelValue, modalId: "discard-modal", contentId: "content-discard-modal", primaryText: discardPrimaryText, secondayText: discardSecondaryText }), _jsx(DeleteModal, { isOpen: openDeleteFileModal, onPrimaryClick: (event) => removeTemplateComponent(event, componentPosition), onSecondaryClick: (event) => closeDeleteModalHandler(event), modalContent: deleteModalInfo, modalHeading: deleteModalHeading, ariaLabelValue: deleteModalLabel, modalId: "delete-modal", contentId: "content-delete-modal" }), _jsx(DiscardModal, { isOpen: isModalOpen, onPrimaryClick: (event) => saveTemplateCreation(event, "PUBLISH DISTRIBUTE NOW"), onSecondaryClick: (event) => saveTemplateCreation(event, "PUBLISH DISTRIBUTE LATER"), onClose: (event) => closePublishModalHandler(event), modalContent: distributeModalContentText, modalHeading: distributeModalHeadingText, ariaLabelValue: "", modalId: "publish-modal", contentId: "content-publish-modal", primaryText: distributeNowText, secondayText: distributeLaterText }), _jsx(InformationModal, { isOpen: isOpen, onPrimaryClick: (event) => closeInfoModalHandler(event), modalContent: modalContentText, modalHeading: modalHeadingText, ariaLabelValue: modalHeadingText, modalId: "information-modal", contentId: "content-information-modal" }), _jsx("div", { className: "sr-only", id: "dialog-wrapper-bottom", tabIndex: 0 })] })));
}
